import {
  EnvironmentProviders,
  inject,
  makeEnvironmentProviders,
  provideEnvironmentInitializer,
  DOCUMENT,
} from '@angular/core';
import { setWorkerUrl } from 'maplibre-gl';

/**
 * Fichier du worker maplibre-gl, copié tel quel à la racine du build par la section
 * `assets` de chaque application (avec son voisin `maplibre-gl-shared.mjs`, qu'il importe
 * par chemin relatif : les deux doivent rester côte à côte et garder leur nom).
 */
export const MAPLIBRE_WORKER_FILE = 'maplibre-gl-worker.mjs';

/** URL du worker, résolue par rapport au `<base href>` de l'application. */
export function maplibreWorkerUrl(baseUri: string): string {
  return new URL(MAPLIBRE_WORKER_FILE, baseUri).href;
}

/**
 * Indique à maplibre-gl où charger son worker.
 *
 * Depuis la version 6, maplibre-gl est distribué en modules ES uniquement et ne transporte plus
 * son worker dans le bundle principal : il le charge comme un vrai fichier. Derrière un bundler
 * (esbuild ici), l'emplacement ne peut pas être deviné de façon fiable — notamment sous
 * `nx serve`, où la dépendance est servie depuis le cache de Vite — d'où cet appel explicite,
 * une fois, au démarrage de l'application. Sans lui (ou sans les deux fichiers copiés), la carte
 * s'affiche mais aucune tuile vectorielle ni source GeoJSON ne se charge.
 *
 * Dans un point d'entrée à part (`@wheere-front/shared-map-libre/worker`) pour que le barrel de
 * la bibliothèque continue de ne pas importer maplibre-gl à l'exécution.
 */
export function provideMaplibreWorker(): EnvironmentProviders {
  return makeEnvironmentProviders([
    provideEnvironmentInitializer(() => setWorkerUrl(maplibreWorkerUrl(inject(DOCUMENT).baseURI))),
  ]);
}
